import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function NoResultTransaction({ handleReset }) {
  return (
    <Stack
      alignItems="center"
      direction="column"
      py="32px"
      spacing="8px"
    >
      <Text
        color="secondary"
        size="xl"
        weight="medium"
      >
        No results
      </Text>
      <Text
        color="secondary"
        size="md"
      >
        Try another search
      </Text>
      <Button
        color="info"
        onClick={handleReset}
        size="small"
        variant="text"
      >
        Reset filters
      </Button>
    </Stack>
  );
}

NoResultTransaction.propTypes = {
  handleReset: PropTypes.func.isRequired
};
